<template>
  <div />
</template>

<script>

/**
 * Vue: Contact us (contact-us)
 * -----------------------------------------------------------------------------
 * Contact us page.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'ContactUs',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {

    }
  },

  computed: {
    missingFields() {
      const requiredFields = document.querySelectorAll(`.contact-us--${this.liquid.sectionId} [js-contact-form="required"]`)

      return Array.from(requiredFields).some((field) => field.validationMessage !== '')
    },
  },

  mounted() {
    this.setEventListeners()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
      openOverlay: 'overlays/open',
    }),

    setEventListeners() {
      const currentSection = `.contact-us--${this.liquid.sectionId}`
      const cta = document.querySelector(`${currentSection} [js-contact-us="form"]`)
      const close = document.querySelector(`${currentSection} [js-contact-form="close"]`)
      const submit = document.querySelector(`${currentSection} [js-contact-form="submit"]`)

      cta.addEventListener('click', () => {
        this.openContactForm()
      })

      close.addEventListener('click', () => {
        this.closeContactForm()
      })

      submit.addEventListener('click', () => {
        this.submitContactForm()
      })
    },

    async submitContactForm() {
      if (this.missingFields) {
        return
      }

      const form = document.getElementById('contact_form')
      await form.submit()
      this.closeContactForm()
    },

    openContactForm() {
      this.openOverlay({
        component: 'contact-us-form',
        namespace: 'contactUs',
        ignoreDismissed: true,
      })
    },

    closeContactForm() {
      this.closeOverlay('contactUs')
    },
  },
}
</script>

<style lang="scss">
@import './contact-us';
@import './contact-form';
</style>
